if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest('.thb-product-detail');
      if (this.productWrapper) {
        this.productSlider = this.productWrapper.querySelector('.product-images') ? this.productWrapper.querySelector('.product-images') : this.productWrapper.querySelector('.product-quick-images');
        this.thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');
        this.hideVariants = this.productSlider.dataset.hideVariants === 'true';
      }
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
      this.setupColorFiltering();

      
      // Initialize metafield-based exclusions
      this.initializeExclusions();
      
      // Wait for the color-swatch-image script to be loaded
      this.waitForColorSwatchData().then(() => {
        this.updateColorSwatchImages();
        // Set up observer to watch for label changes
        this.setupColorSwatchObserver();
      });
      
      // Trigger initial color filtering
      setTimeout(() => {
        this.updateColorBasedImages();
        // Also set up initial collage layout
        this.setupInitialCollageLayout();
            this.updateBackorderDate();
      }, 100);
    }

    /**
     * Initialize color and size exclusions from metafields
     */
    initializeExclusions() {
      // Parse exclude colors from data attribute
      this.excludeColors = [];
      const excludeColorsAttr = this.dataset.excludeColors;
      if (excludeColorsAttr) {
        try {
          this.excludeColors = JSON.parse(excludeColorsAttr);
        } catch (e) {
          console.warn('Failed to parse exclude_colors:', e);
        }
      }

      // Parse exclude sizes mapping from data attribute
      this.excludeSizes = {};
      const excludeSizesAttr = this.dataset.excludeSizes;
      if (excludeSizesAttr) {
        try {
          this.excludeSizes = JSON.parse(excludeSizesAttr);
        } catch (e) {
          console.warn('Failed to parse exclude_sizes:', e);
        }
      }

      // Apply initial exclusions (with scroll prevention flag)
      this.isApplyingExclusions = true;
      this.applyColorExclusionsQuietly();
      this.applySizeExclusionsQuietly();
      this.isApplyingExclusions = false;
    }

    /**
     * Hide colors that are in the exclude_color metafield (without triggering change events)
     */
    applyColorExclusionsQuietly() {
      if (!this.excludeColors || this.excludeColors.length === 0) return;

      // Find the color fieldset
      const colorFieldset = this.findColorFieldset();
      if (!colorFieldset) return;

      // Get all color inputs/options
      const inputs = colorFieldset.querySelectorAll('input[type="radio"]');
      const select = colorFieldset.querySelector('select');

      if (inputs.length > 0) {
        inputs.forEach(input => {
          const colorValue = input.value.toLowerCase().trim();
          const label = colorFieldset.querySelector(`label[for="${input.id}"]`);
          
          if (this.excludeColors.includes(colorValue)) {
            input.style.display = 'none';
            input.disabled = true;
            if (label) label.style.display = 'none';
            
            // If this was the selected color, select the first available one quietly
            if (input.checked) {
              const firstAvailable = Array.from(inputs).find(inp => {
                const val = inp.value.toLowerCase().trim();
                return !this.excludeColors.includes(val);
              });
              if (firstAvailable) {
                firstAvailable.checked = true;
                this.updateOptionsQuietly();
              }
            }
          }
        });
      } else if (select) {
        const options = select.querySelectorAll('option');
        let needsReselect = false;
        
        options.forEach(option => {
          const colorValue = option.value.toLowerCase().trim();
          if (this.excludeColors.includes(colorValue)) {
            option.style.display = 'none';
            option.disabled = true;
            if (option.selected) needsReselect = true;
          }
        });

        if (needsReselect) {
          const firstAvailable = Array.from(options).find(opt => {
            const val = opt.value.toLowerCase().trim();
            return !this.excludeColors.includes(val) && !opt.disabled;
          });
          if (firstAvailable) {
            select.value = firstAvailable.value;
            this.updateOptionsQuietly();
          }
        }
      }
    }

    /**
     * Update options and variant without triggering scroll behavior
     */
    updateOptionsQuietly() {
      this.updateOptions();
      this.updateMasterId();
      this.updateVariantText();
      this.setDisabled();
      if (this.currentVariant) {
        this.updateVariantInput();
      }
    }

    /**
     * Apply size exclusions without triggering change events (prevents scroll jump)
     */
    applySizeExclusionsQuietly() {
      if (!this.excludeSizes || Object.keys(this.excludeSizes).length === 0) return;

      // Get currently selected color
      const selectedColor = this.getSelectedColorValue();
      if (!selectedColor) return;

      // Get sizes to exclude for this color
      const sizesToExclude = this.excludeSizes[selectedColor.toLowerCase().trim()] || [];

      // Find the size fieldset
      const sizeFieldset = this.findSizeFieldset();
      if (!sizeFieldset) return;

      // Get all size inputs/options
      const inputs = sizeFieldset.querySelectorAll('input[type="radio"]');
      const select = sizeFieldset.querySelector('select');

      if (inputs.length > 0) {
        let needsReselect = false;
        
        inputs.forEach(input => {
          const sizeValue = input.value.toLowerCase().trim();
          const label = sizeFieldset.querySelector(`label[for="${input.id}"]`);
          
          const shouldExclude = sizesToExclude.some(excludedSize => {
            const normalizedExcluded = excludedSize.toLowerCase().trim();
            return sizeValue === normalizedExcluded || sizeValue.includes(normalizedExcluded);
          });
          
          if (shouldExclude) {
            input.style.display = 'none';
            input.disabled = true;
            if (label) label.style.display = 'none';
            if (input.checked) needsReselect = true;
          } else {
            input.style.display = '';
            input.disabled = false;
            if (label) label.style.display = '';
          }
        });

        // If selected size was excluded, select the first available one quietly
        if (needsReselect) {
          const firstAvailable = Array.from(inputs).find(inp => !inp.disabled && inp.style.display !== 'none');
          if (firstAvailable) {
            firstAvailable.checked = true;
            // Update state without triggering change event
            this.updateOptionsQuietly();
          }
        }
      } else if (select) {
        const options = select.querySelectorAll('option');
        let needsReselect = false;
        
        options.forEach(option => {
          const sizeValue = option.value.toLowerCase().trim();
          const shouldExclude = sizesToExclude.some(excludedSize => {
            const normalizedExcluded = excludedSize.toLowerCase().trim();
            return sizeValue === normalizedExcluded || sizeValue.includes(normalizedExcluded);
          });
          
          if (shouldExclude) {
            option.style.display = 'none';
            option.disabled = true;
            if (option.selected) needsReselect = true;
          } else {
            option.style.display = '';
            option.disabled = false;
          }
        });

        if (needsReselect) {
          const firstAvailable = Array.from(options).find(opt => !opt.disabled && opt.style.display !== 'none');
          if (firstAvailable) {
            select.value = firstAvailable.value;
            // Update state without triggering change event
            this.updateOptionsQuietly();
          }
        }
      }
    }

    /**
     * Find the color option fieldset
     */
    findColorFieldset() {
      const colorNames = ['color', 'colour', 'couleur', 'farbe'];
      return Array.from(this.querySelectorAll('fieldset')).find(fieldset => {
        const handle = fieldset.dataset.handle?.toLowerCase() || '';
        const legend = fieldset.querySelector('legend, .form__label')?.textContent?.toLowerCase() || '';
        return colorNames.some(name => handle.includes(name) || legend.includes(name));
      });
    }

    /**
     * Find the size option fieldset
     */
    findSizeFieldset() {
      const sizeNames = ['size', 'taille', 'größe', 'grosse'];
      return Array.from(this.querySelectorAll('fieldset')).find(fieldset => {
        const handle = fieldset.dataset.handle?.toLowerCase() || '';
        const legend = fieldset.querySelector('legend, .form__label')?.textContent?.toLowerCase() || '';
        return sizeNames.some(name => handle.includes(name) || legend.includes(name));
      });
    }

    /**
     * Get the currently selected color value
     */
    getSelectedColorValue() {
      const colorFieldset = this.findColorFieldset();
      if (!colorFieldset) return null;

      const checkedInput = colorFieldset.querySelector('input[type="radio"]:checked');
      if (checkedInput) return checkedInput.value;

      const select = colorFieldset.querySelector('select');
      if (select) return select.value;

      return null;
    }

    /**
     * Set up MutationObserver to watch for label changes
     */
    setupColorSwatchObserver() {
      // Flag to prevent recursive updates
      this.isUpdatingColorSwatches = false;
      
      // Initialize processedLabelIds if it doesn't exist
      if (!this.processedLabelIds) {
        this.processedLabelIds = new Set();
      }
      
      // Debounced update function
      const debouncedUpdate = () => {
        if (this.isUpdatingColorSwatches) {
          return; // Skip if already updating
        }
        
        clearTimeout(this.colorSwatchUpdateTimeout);
        this.colorSwatchUpdateTimeout = setTimeout(() => {
          if (!this.isUpdatingColorSwatches) {
            this.isUpdatingColorSwatches = true;
            this.updateColorSwatchImages().finally(() => {
              this.isUpdatingColorSwatches = false;
            });
          }
        }, 300); // Increased debounce time
      };
      
      // Watch for changes in the variant selects component
      const observer = new MutationObserver((mutations) => {
        let shouldUpdate = false;
        
        mutations.forEach((mutation) => {
          // Only check for meaningful changes
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            // Check if labels were added
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1) { // Element node
                // Check if it's a label with color swatch
                if (node.tagName === 'LABEL' && node.getAttribute('style') && node.getAttribute('style').includes('--option-color')) {
                  const labelId = node.getAttribute('for') || node.textContent.trim();
                  if (!this.processedLabelIds.has(labelId)) {
                    shouldUpdate = true;
                  }
                } else if (node.querySelectorAll && node.querySelectorAll('label[style*="--option-color"]').length > 0) {
                  shouldUpdate = true;
                }
              }
            });
          }
          
          // Check if label class changed (disabled -> enabled)
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const target = mutation.target;
            if (target.tagName === 'LABEL' && target.getAttribute('style') && target.getAttribute('style').includes('--option-color')) {
              const wasDisabled = mutation.oldValue && mutation.oldValue.includes('is-disabled');
              const isNowEnabled = !target.classList.contains('is-disabled');
              // Only update if label became enabled
              if (wasDisabled && isNowEnabled) {
                shouldUpdate = true;
              }
            }
          }
        });
        
        if (shouldUpdate) {
          debouncedUpdate();
        }
      });
      
      // Observe only the variant-selects component (not the whole document)
      observer.observe(this, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class'], // Only watch class changes, not style (to avoid loops)
        attributeOldValue: true
      });
      
      // Listen for input changes (variant selection changes)
      this.addEventListener('change', (e) => {
        // Only trigger if it's a variant input change
        if (e.target.matches('input[type="radio"], select')) {
          debouncedUpdate();
        }
      });
      
      // Store observer for cleanup if needed
      this.colorSwatchObserver = observer;
    }

    /**
     * Wait for the color-swatch-image script to be available
     */
    waitForColorSwatchData() {
      return new Promise((resolve) => {
        const checkScript = () => {
          const script = document.getElementById('color-swatch-image');
          if (script && script.textContent.trim()) {
            resolve();
          } else {
            // Retry after a short delay
            setTimeout(checkScript, 50);
          }
        };
        checkScript();
      });
    }

    onVariantChange(evt) {
      if (this.isApplyingExclusions) {
        return;
      }
      if (evt && evt.target && evt.target.matches && evt.target.matches('[data-custom-donation-input]')) {
        return;
      }

      const isDonationProduct = this.dataset.customDonationProduct === 'true';

      this.updateOptions();
      this.updateMasterId();
      if (!isDonationProduct) {
        this.toggleAddButton(true, '', false);
      }
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();
      this.updateBackorderDate();

      this.applySizeExclusionsQuietly();

      if (!this.currentVariant) {
        if (!isDonationProduct) {
          this.toggleAddButton(true, '', true);
        }
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
      }
      this.updateOther();
      
      // Update color-based image filtering
      this.updateColorBasedImages();
      
      // Update color swatch images when variant changes
      // Use a small delay to ensure DOM is updated
      if (!this.isUpdatingColorSwatches) {
        setTimeout(() => {
          this.waitForColorSwatchData().then(() => {
            this.updateColorSwatchImages();
          });
        }, 200);
      }
      
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.option_keys = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
          this.option_keys.push(fieldset.querySelector('select').name);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
          this.option_keys.push(fieldset.querySelector('input').name);
        }
      });
      this.dataset.options = this.options;
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value="${option}"]`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
         this.other[0].updateBackorderDate();
      }
    }

    hideBackorderDate(backorderElement) {
      if (!backorderElement) return;
      backorderElement.classList.remove('active');
      backorderElement.style.removeProperty('visibility');
      backorderElement.style.removeProperty('display');
    }

    updateBackorderDate() {
      const backorderElement = document.getElementById(`backorder-date-${this.dataset.section}`);
      const hiddenInput = document.getElementById(`estimated-ship-date-${this.dataset.section}`);
      const syncEstimatedShipProperty = (rawValue) => {
        if (!hiddenInput) return;
        const v = rawValue != null && String(rawValue).trim() !== '' ? String(rawValue).trim() : '';
        if (v) {
          hiddenInput.value = v;
          hiddenInput.disabled = false;
        } else {
          hiddenInput.value = '';
          hiddenInput.disabled = true;
        }
      };
      if (!backorderElement) {
        syncEstimatedShipProperty('');
        return;
      }

      if (!this.currentVariant) {
        this.hideBackorderDate(backorderElement);
        syncEstimatedShipProperty('');
        return;
      }

      const variantData = this.getVariantData();
      if (!variantData || variantData.length === 0) {
        this.hideBackorderDate(backorderElement);
        syncEstimatedShipProperty('');
        return;
      }

      const currentVariantData = variantData.find(v => v.id === this.currentVariant.id);
      if (!currentVariantData) {
        this.hideBackorderDate(backorderElement);
        syncEstimatedShipProperty('');
        return;
      }

      const inventoryQuantity = currentVariantData.inventory_quantity;
      if (inventoryQuantity != null && inventoryQuantity > 0) {
        this.hideBackorderDate(backorderElement);
        syncEstimatedShipProperty('');
        return;
      }

      const backorderDate = currentVariantData?.metafields?.global?.backordered_date;
      if (!backorderDate || backorderDate === null || backorderDate === 'null') {
        this.hideBackorderDate(backorderElement);
        syncEstimatedShipProperty('');
        return;
      }

      const dateElement = backorderElement.querySelector('.backorder-date--value');
      if (!dateElement) {
        this.hideBackorderDate(backorderElement);
        syncEstimatedShipProperty('');
        return;
      }

      let formattedDate = backorderDate;
      // try {
      //   const date = new Date(backorderDate);
      //   if (!isNaN(date.getTime())) {
      //     formattedDate = date.toLocaleDateString('en-US', {
      //       year: 'numeric',
      //       month: 'numeric',
      //       day: 'numeric'
      //     });
      //   }

      // } catch (e) {
      //   console.error('[Backorder] Error formatting date:', e);
      //   formattedDate = backorderDate;
      // }

       try {
              // Parse date without timezone conversion to avoid date shifts
              // Extract date part from ISO string (YYYY-MM-DDTHH:mm:ss or YYYY-MM-DD)
              let dateStr = String(backorderDate).trim();
              
              // Remove timezone info and time if present (e.g., "2026-05-06T00:00:00Z" -> "2026-05-06")
              if (dateStr.includes('T')) {
                dateStr = dateStr.split('T')[0];
              }
              // Remove timezone offset if present (e.g., "2026-05-06+05:30" -> "2026-05-06")
              if (dateStr.includes('+') || (dateStr.includes('-') && dateStr.match(/\d{4}-\d{2}-\d{2}-\d{2}:\d{2}/))) {
                dateStr = dateStr.split(/[+-]/)[0];
              }
              
              // Parse date parts (expecting YYYY-MM-DD format from Shopify)
              const dateParts = dateStr.split(/[-/]/);
              if (dateParts.length >= 3) {
                let year, month, day;
                
                // Check if first part is year (4 digits) - Shopify typically uses YYYY-MM-DD
                if (dateParts[0].length === 4) {
                  // ISO format: YYYY-MM-DD
                  // year = parseInt(dateParts[0], 10);
                  // month = parseInt(dateParts[1], 10);
                  // day = parseInt(dateParts[2], 10);
                   year = parseInt(dateParts[0], 10);
                  const a = parseInt(dateParts[1], 10);
                  const b = parseInt(dateParts[2], 10);
                  if (a >= 1 && a <= 12 && b >= 1 && b <= 31) {
                    month = a;
                    day = b;
                  } else if (b >= 1 && b <= 12 && a >= 1 && a <= 31) {
                    month = b;
                    day = a;
                  } else {
                    month = a;
                    day = b;
                  }
                } else {
                  // Handle other formats - try to detect DD/MM/YYYY vs MM/DD/YYYY
                  const firstPart = parseInt(dateParts[0], 10);
                  const secondPart = parseInt(dateParts[1], 10);
                  
                  if (firstPart > 12 && secondPart <= 12) {
                    // DD/MM/YYYY format
                    day = firstPart;
                    month = secondPart;
                    year = parseInt(dateParts[2], 10);
                  } else if (firstPart <= 12 && secondPart > 12) {
                    // MM/DD/YYYY format
                    month = firstPart;
                    day = secondPart;
                    year = parseInt(dateParts[2], 10);
                  } else {
                    // Default to MM/DD/YYYY if ambiguous
                    month = firstPart;
                    day = secondPart;
                    year = parseInt(dateParts[2], 10);
                  }
                }
                
                // Validate and format as MM/DD/YYYY
                // if (year && month >= 1 && month <= 12 && day >= 1 && day <= 31) {
                //   formattedDate = `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`;
                // }
                 if (year && month >= 1 && month <= 12 && day >= 1 && day <= 31) {
                  formattedDate = `${String(month).padStart(2, '0')}/${String(day).padStart(2, '0')}/${year}`;
                }
              }
            } catch (e) {
              // If parsing fails, use original value 
              formattedDate = backorderDate;
            }
      syncEstimatedShipProperty(formattedDate);
      dateElement.textContent = formattedDate;
      backorderElement.style.removeProperty('visibility');
      backorderElement.style.removeProperty('display');
      setTimeout(() => {
       backorderElement.style.visibility = 'visible';
          if (!backorderElement.classList.contains('active')) {
   backorderElement.classList.add('active');
 }
     }, 50); 
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      if (!this.productSlider) return;
      let mediaId = `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      let activeMedia = this.productSlider.querySelector(mediaId);
      
      // Check if the active media is hidden (has alt="hidden")
      if (activeMedia && this.isMediaHidden(activeMedia)) {
        activeMedia = null; // Treat hidden media as if it doesn't exist
      }
      
      // Check if the active media matches the selected color
      if (activeMedia) {
        const selectedColor = this.getSelectedColor();
        if (selectedColor) {
          const mediaColor = this.getMediaColor(activeMedia);
          if (mediaColor && mediaColor !== selectedColor) {
            // If media doesn't match selected color, try to find a matching one
            const bestMatch = this.findBestMatchingImage(selectedColor);
            if (bestMatch) {
              activeMedia = bestMatch;
              mediaId = `#Slide-${this.dataset.section}-${activeMedia.dataset.mediaId}`;
            } else {
              activeMedia = null;
            }
          }
        }
      }
      
      if (this.thumbnails) {
        this.setActiveMediaSlider(mediaId, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider);
      } else {
        this.setActiveMedia(activeMedia);
      }
    }

    setActiveMedia(activeMedia) {
  
      this.productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      this.setImageSetMedia();

      // Only proceed if activeMedia exists and is not hidden
      if (activeMedia) {
        activeMedia.classList.add('is-active');
        activeMedia.parentElement.prepend(activeMedia);
      }
    }
    setActiveMediaSlider(mediaId, thumbId, productSlider) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);

      // Check if the active media is hidden (has alt="hidden")
      if (activeMedia && this.isMediaHidden(activeMedia)) {
        activeMedia = null; // Treat hidden media as if it doesn't exist
      }

      if (flkty && this.hideVariants) {
        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });
        if (this.thumbnails) {
          if (this.thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            this.thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(this.thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });
        }

        // Only proceed if activeMedia exists and is not hidden
        if (activeMedia) {
          activeMedia.classList.add('is-active');
          activeMedia.classList.add('is-initial-selected');

          this.setImageSetMedia();

          if (this.thumbnails) {
            let activeThumb = this.thumbnails.querySelector(thumbId);
            if (activeThumb) {
              activeThumb.classList.add('is-active');
              activeThumb.classList.add('is-initial-selected');
            }
          }

          productSlider.reInit(this.imageSetIndex);
          productSlider.selectCell(mediaId);
        }

      } else if (flkty && activeMedia) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {

      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();
      this.renderProductInfoRequest = (this.renderProductInfoRequest || 0) + 1;
      const requestId = this.renderProductInfoRequest;

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          if (requestId !== this.renderProductInfoRequest) {
            return;
          }
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
          this.updateBackorderDate();
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
          
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data) {
        let selected_options = false;
        if (this.currentVariant) {
          selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });
        } else {
          let found_option = variant_data.find(option => {
            return option.options && option.options[0] === this.options[0];
          });
          if (found_option) {
            selected_options = [
              {
                "value": this.options[0],
                "index": "option1"
              },
              {
                "value": found_option.options[1],
                "index": "option2"
              }
            ];
          } else {
            return;
          }
        }

        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    isMediaHidden(mediaElement) {
      if (!mediaElement) return false;
      // Check the alt attribute of the media image, not the zoom element's title
      const mediaImage = mediaElement.querySelector('img');
      if (mediaImage) {
        const alt = mediaImage.getAttribute('alt') || '';
        return alt === 'hidden';
      }
      return false;
    }

    getMediaColor(mediaElement) {
      if (!mediaElement) return null;
      // Check the alt attribute of the media image, not the zoom element's title
      const mediaImage = mediaElement.querySelector('img');
      if (mediaImage) {
        const alt = mediaImage.getAttribute('alt') || '';
        // Extract color from alt tag (assuming format like "Color Name" or "color-name")
        if (alt && alt !== 'hidden') {
          return alt.toLowerCase().trim();
        }
      }
      return null;
    }

    getSelectedColor() {
      // Try multiple ways to find color selection
      let selectedColor = null;
      
      // Method 1: Look for fieldsets with color-related names
      const colorFieldsets = this.querySelectorAll('fieldset');
      for (let fieldset of colorFieldsets) {
        const label = fieldset.querySelector('label, .form__label');
        if (label) {
          const labelText = label.textContent.toLowerCase();
          if (labelText.includes('color') || labelText.includes('colour')) {
            const selectedInput = fieldset.querySelector('input:checked, select option:checked');
            if (selectedInput) {
              selectedColor = selectedInput.value.toLowerCase().trim();
              break;
            }
          }
        }
      }
      
      // Method 2: Look for data attributes
      if (!selectedColor) {
        const colorFieldset = this.querySelector('fieldset[data-option-name*="color" i], fieldset[data-option-name*="colour" i]');
        if (colorFieldset) {
          const selectedInput = colorFieldset.querySelector('input:checked, select option:checked');
          if (selectedInput) {
            selectedColor = selectedInput.value.toLowerCase().trim();
            
          }
        }
      }
      
      // Method 3: Look through all options for color-related values
      if (!selectedColor) {
        const allInputs = this.querySelectorAll('input:checked, select option:checked');
        for (let input of allInputs) {
          const value = input.value.toLowerCase();
          // Common color names to check
          const colorNames = ['red', 'blue', 'green', 'yellow', 'black', 'white', 'pink', 'purple', 'orange', 'brown', 'gray', 'grey'];
          if (colorNames.some(color => value.includes(color))) {
            selectedColor = value;
          
            break;
          }
        }
      }
      
   
      return selectedColor;
    }

    filterImagesByColor(images, selectedColor) {
      if (!selectedColor) return images;
      
      return Array.from(images).filter(element => {
        const mediaColor = this.getMediaColor(element);
        return mediaColor === selectedColor || mediaColor === null; // Include images without color tags
      });
    }

    setupColorFiltering() {
     
      
      // Add event listeners for all variant inputs
      const allInputs = this.querySelectorAll('input[type="radio"], input[type="checkbox"], select');
     
      
      allInputs.forEach((input, index) => {
        input.addEventListener('change', () => {
          // Small delay to ensure the variant change has been processed
          setTimeout(() => {
            this.updateColorBasedImages();
          }, 50);
        });
      });
      
      // Also listen for clicks on color swatches or buttons
      const colorElements = this.querySelectorAll('[data-color], .color-swatch, .color-option');
      colorElements.forEach(element => {
        element.addEventListener('click', () => {
          
          setTimeout(() => {
            this.updateColorBasedImages();
          }, 50);
        });
      });
      

      
      // Add global methods for testing
      window.testColorFiltering = () => {
        this.updateColorBasedImages();
      };
      
      window.debugColorFiltering = () => {
        this.updateColorBasedImages();
      };
    }

    updateColorBasedImages() {
      if (!this.productSlider) {
        return;
      }
      
      const selectedColor = this.getSelectedColor();
      const allImages = this.productSlider.querySelectorAll('.product-images__slide');
      
      let visibleCount = 0;
      
      // Show/hide images based on color
      allImages.forEach((image, index) => {
        const mediaColor = this.getMediaColor(image);
        const isHidden = this.isMediaHidden(image);
        
    
        if (isHidden) {
          image.style.display = 'none';
        } else if (selectedColor) {
          // Show images that match the selected color or have no color tag
          if (mediaColor === selectedColor || mediaColor === null) {
            image.style.display = '';
            visibleCount++;
          } else {
            image.style.display = 'none';
          }
        } else {
          // If no color selected, show all non-hidden images
          image.style.display = '';
          visibleCount++;
        }
      });
      
      // Show the first matching image when color changes
      if (selectedColor && visibleCount > 0) {
        this.showFirstMatchingImage(selectedColor, Array.from(allImages));
      } else if (!selectedColor) {
        // If no color selected, remove color-first-selected class from all images
        Array.from(allImages).forEach(img => {
          img.classList.remove('color-first-selected');
        });
      }
      
      // Update active media based on color selection
      this.updateMedia();
      
      // Trigger pagination resize for sliders
      if (!this.thumbnails) {
        setTimeout(() => {
          const productSlider = this.productSlider.querySelector('product-slider');
          if (productSlider && typeof productSlider.onPaginationResize === 'function') {
            productSlider.onPaginationResize();
          }
        }, 100);
      }
    }

    findBestMatchingImage(selectedColor) {
      if (!this.productSlider || !selectedColor) return null;
      
      const allImages = this.productSlider.querySelectorAll('.product-images__slide');
      const matchingImages = this.filterImagesByColor(Array.from(allImages), selectedColor);
      
      if (matchingImages.length > 0) {
        return matchingImages[0];
      }
      
      // If no exact match, return the first non-hidden image
      const visibleImages = Array.from(allImages).filter(image => {
        return !this.isMediaHidden(image) && image.style.display !== 'none';
      });
      
      return visibleImages.length > 0 ? visibleImages[0] : null;
    }

    showFirstMatchingImage(selectedColor, allImages) {
      // Convert NodeList to Array
      const imagesArray = Array.from(allImages);
      
      const firstMatchingImage = imagesArray.find(image => {
        const mediaColor = this.getMediaColor(image);
        const isHidden = this.isMediaHidden(image);
        return !isHidden && (mediaColor === selectedColor || mediaColor === null) && image.style.display !== 'none';
      });
      
      if (firstMatchingImage) {
        // Remove active and color-first-selected classes from all images
        imagesArray.forEach(img => {
          img.classList.remove('is-active', 'color-first-selected');
        });
        
        // Add active class to first matching image
        firstMatchingImage.classList.add('is-active');
        
        // Add color-first-selected class for collage layout
        firstMatchingImage.classList.add('color-first-selected');
        
        // Move it to the front for grid display
        firstMatchingImage.parentElement.prepend(firstMatchingImage);
        
      }
    }

    setupInitialCollageLayout() {
      if (!this.productSlider) return;
      
      // Check if this is a collage layout
      const isCollageLayout = this.productSlider.classList.contains('product-images--collage');
      if (!isCollageLayout) return;
      
      const allImages = this.productSlider.querySelectorAll('.product-images__slide');
      const visibleImages = Array.from(allImages).filter(image => {
        return !this.isMediaHidden(image) && image.style.display !== 'none';
      });
      
      if (visibleImages.length > 0) {
        // Remove color-first-selected class from all images
        Array.from(allImages).forEach(img => {
          img.classList.remove('color-first-selected');
        });
        
        // Add color-first-selected class to the first visible image
        visibleImages[0].classList.add('color-first-selected');
        
      }
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }

    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }
      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productSlider.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

      // Filter out hidden media elements (those with alt="hidden")
      selected_set_images = Array.from(selected_set_images).filter(element => {
        return !this.isMediaHidden(element);
      });

      // Apply color-based filtering
      const selectedColor = this.getSelectedColor();
      selected_set_images = this.filterImagesByColor(selected_set_images, selectedColor);

      if (this.hideVariants) {
        if (this.thumbnails) {
          // Product images
          this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_images.forEach(thumb => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });

          // Product thumbnails
          this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_thumbs.forEach(thumb => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });
        } else {
          // Product images
          this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_images.forEach(thumb => {
            if (thumb.dataset.group === group) {
              thumb.classList.add('is-active');
            }
          });
        }

      } else {

        if (!this.thumbnails) {
          let set_images = Array.from(selected_set_images).filter(function (element) {
            return element.dataset.group === group;
          });
          set_images.forEach(thumb => {
            thumb.parentElement.prepend(thumb);
          });
        }

      }
      if (!this.thumbnails) {
        setTimeout(() => {
          this.productSlider.querySelector('product-slider').onPaginationResize();
        }, 100);
      }
    }

    createAvailableOptionsTree(variants, currentlySelectedValues) {
      // Reduce variant array into option availability tree
      return variants.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {
          const optionIndex = parseInt(index.replace('option', '')) - 1; // Convert option1 -> 0, option2 -> 1, etc.
          
          if (!variant.options || variant.options[optionIndex] === null) return;

          let entry = options[index].find(option => option.value === variant.options[optionIndex]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = { value: variant.options[optionIndex], isUnavailable: true };
            options[index].push(entry);
          }

          const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === 'option1');
          const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === 'option2');

          switch (index) {
            case 'option1':
              // Option1 inputs should always remain enabled based on all available variants
              entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              break;
            case 'option2':
              // Option2 inputs should remain enabled based on available variants that match first option group
              if (currentOption1 && variant.options[0] === currentOption1.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
              break;
            case 'option3':
              // Option 3 inputs should remain enabled based on available variants that match first and second option group
              if (currentOption1 && variant.options[0] === currentOption1.value && currentOption2 && variant.options[1] === currentOption2.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
          }
        });

        return options;
      }, { option1: [], option2: [], option3: [] });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    /**
     * Update color swatch images from JSON data
     */
    updateColorSwatchImages() {
      // Prevent recursive calls
      if (this.isUpdatingColorSwatches) {
        return Promise.resolve();
      }
      
      // Initialize processedLabelIds if it doesn't exist
      if (!this.processedLabelIds) {
        this.processedLabelIds = new Set();
      }
      
      this.isUpdatingColorSwatches = true;
      
      // Get the color-swatch-image JSON from theme.liquid
      const colorSwatchScript = document.getElementById('color-swatch-image');
    
      if (!colorSwatchScript || !colorSwatchScript.textContent.trim()) {
        // Try to handle products without options using metafields
        this.updateColorSwatchImagesFromMetafields();
        this.isUpdatingColorSwatches = false;
        return Promise.resolve();
      }

      let colorSwatchData = {};
      try {
        const scriptContent = colorSwatchScript.textContent.trim();
        const parsedData = JSON.parse(scriptContent);

        // Check if data is nested under "image" property
        if (parsedData.image && typeof parsedData.image === 'object') {
          colorSwatchData = parsedData.image;
        } else {
          // Use the data directly if it's not nested
          colorSwatchData = parsedData;
        }
      } catch (e) {
        this.updateColorSwatchImagesFromMetafields();
        this.isUpdatingColorSwatches = false;
        return Promise.resolve();
      }

      // Check if data is empty or null
      if (!colorSwatchData || Object.keys(colorSwatchData).length === 0) {
      
        this.updateColorSwatchImagesFromMetafields();
        this.isUpdatingColorSwatches = false;
        return Promise.resolve();
      }

      // Check if this is the metafield format (keys are just product IDs)
      const firstKey = Object.keys(colorSwatchData)[0];
      if (!firstKey) {
        this.updateColorSwatchImagesFromMetafields();
        this.isUpdatingColorSwatches = false;
        return Promise.resolve();
      }

      // Check if key contains " - " (variant format) or is just a number (metafield format)
      const hasVariantFormat = firstKey.includes(' - ');
      
      if (!hasVariantFormat) {
        // This is metafield format, handle it differently
        this.updateColorSwatchImagesFromMetafields();
        this.isUpdatingColorSwatches = false;
        return Promise.resolve();
      }

      // Get the current product ID from the page
      const productWrapper = this.closest('.thb-product-detail');
      let currentProductId = null;
      if (productWrapper) {
        currentProductId = productWrapper.dataset.productId || window.theme?.settings?.product_id;
      }
      
      // Extract all unique product IDs from the JSON keys
      const productIds = new Set();
      Object.keys(colorSwatchData).forEach(key => {
        const match = key.match(/^(\d+)\s*-\s*(.+)$/);
        if (match) {
          productIds.add(match[1]);
        }
      });
      
      
      // Determine which product ID to use (prefer current product ID if it exists in JSON)
      let primaryProductId = currentProductId && productIds.has(currentProductId.toString()) 
        ? currentProductId.toString() 
        : Array.from(productIds)[0];

      // Loop through all labels with --option-color CSS variable within this component
      const allLabels = this.querySelectorAll('label[style*="--option-color"]');
      
      // Also check globally for labels (for sticky variant selects and other instances)
      const allLabelsGlobal = document.querySelectorAll('label[style*="--option-color"]');
      
      // Use a Set to avoid processing the same label twice
      const processedLabels = new Set();
      
      // Process all labels
      allLabelsGlobal.forEach((label) => {
        if (!processedLabels.has(label)) {
          const labelId = label.getAttribute('for') || label.textContent.trim();
          processedLabels.add(label);
          
          // Determine the product ID for this specific label by traversing up the DOM
          let labelProductId = primaryProductId;
          const labelProductWrapper = label.closest('.thb-product-detail') || label.closest('[data-product-id]') || label.closest('[data-handle]');
          if (labelProductWrapper) {
            const wrapperId = labelProductWrapper.dataset.productId;
            if (wrapperId && productIds.has(wrapperId.toString())) {
              labelProductId = wrapperId.toString();
            }
          }
          
          // Only use the specific product ID for this label, not all product IDs
          this.updateLabelColorImage(label, colorSwatchData, labelProductId, [labelProductId]);
          this.processedLabelIds.add(labelId);
        }
      });
      
      this.isUpdatingColorSwatches = false;
      return Promise.resolve();
    }

    /**
     * Update a single label's color image
     */
    updateLabelColorImage(label, colorSwatchData, primaryProductId, allProductIds) {
      // Get the inline style to read the --option-color value
      const inlineStyle = label.getAttribute('style') || '';
      const optionColorMatch = inlineStyle.match(/--option-color:\s*([^;]+)/);
      
      if (!optionColorMatch) {
        return;
      }

      let optionColor = optionColorMatch[1].trim();
      
      // Get the color name from multiple sources
      const labelText = label.textContent.trim();
      const labelFor = label.getAttribute('for');
      let inputValue = '';
      
      // Try to get the value from the associated input
      if (labelFor) {
        const input = document.getElementById(labelFor);
        if (input) {
          inputValue = input.value || input.getAttribute('value') || '';
        }
      }
      
      // Normalize the color name (remove quotes, trim, lowercase)
      let normalizedColor = optionColor.replace(/['"]/g, '').trim().toLowerCase();
      
      // If normalized color is empty or looks like a CSS value (rgb, var, etc), try other sources
      if (!normalizedColor || normalizedColor.startsWith('rgb') || normalizedColor.startsWith('var') || normalizedColor.startsWith('#') || normalizedColor.startsWith('hsl')) {
        // Prefer input value, then label text
        normalizedColor = (inputValue || labelText).toLowerCase().trim();
      }
      
    
      let imageUrl = null;
      
      // Try to find match with primary product ID first
      const primaryLookupKey = primaryProductId + ' - ' + normalizedColor;
      imageUrl = colorSwatchData[primaryLookupKey];
      
      if (imageUrl) {
        // console.log('Found exact match with primary product ID:', primaryLookupKey);
      } else {
        // Try all provided product IDs if primary didn't match
        for (const productId of allProductIds) {
          const lookupKey = productId + ' - ' + normalizedColor;
          if (colorSwatchData[lookupKey]) {
            imageUrl = colorSwatchData[lookupKey];
            break;
          }
        }
      }
      
      // If still no match, try case-insensitive search only for the specific product IDs
      if (!imageUrl) {
        const matchingKey = Object.keys(colorSwatchData).find(key => {
          if (!key.includes(' - ')) return false;
          const [keyProductId, ...colorParts] = key.split(' - ');
          // Only match keys that belong to the allowed product IDs
          if (!allProductIds.includes(keyProductId.trim())) return false;
          const keyColor = colorParts.join(' - ').toLowerCase().trim();
          return keyColor === normalizedColor;
        });
        if (matchingKey) {
          imageUrl = colorSwatchData[matchingKey];
        }
      }
      
      // If still no match, try fuzzy matching only for the specific product IDs
      if (!imageUrl) {
        const normalizedForFuzzy = normalizedColor.replace(/[^a-z0-9]/g, '');
        const matchingKey = Object.keys(colorSwatchData).find(key => {
          if (!key.includes(' - ')) return false;
          const [keyProductId, ...colorParts] = key.split(' - ');
          // Only match keys that belong to the allowed product IDs
          if (!allProductIds.includes(keyProductId.trim())) return false;
          const keyColor = colorParts.join(' - ').toLowerCase().trim().replace(/[^a-z0-9]/g, '');
          return keyColor === normalizedForFuzzy;
        });
        if (matchingKey) {
          imageUrl = colorSwatchData[matchingKey];
        }
      }

      // If we found an image URL, update the --option-color-image CSS variable
      if (imageUrl) {
        // Remove existing --option-color-image if present
        const cleanedStyle = inlineStyle.replace(/--option-color-image:\s*[^;]+;?/gi, '').trim();
        // Add the new --option-color-image
        const separator = cleanedStyle.endsWith(';') ? ' ' : '; ';
        label.setAttribute('style', cleanedStyle + separator + `--option-color-image: url('${imageUrl}');`);
      } else {
        // console.log('❌ No image found for color:', normalizedColor, 'Available keys:', Object.keys(colorSwatchData).slice(0, 10));
      }
    }

    /**
     * Update color swatch images from metafields for products without options
     */
    updateColorSwatchImagesFromMetafields() {
      // Get the color-swatch-image JSON (for metafield format: "PRODUCT_ID": "URL")
      const colorSwatchScript = document.getElementById('color-swatch-image');
      if (!colorSwatchScript) return;

      let colorSwatchData = {};
      try {
        const parsedData = JSON.parse(colorSwatchScript.textContent);
        
        // Check if data is nested under "image" property
        if (parsedData.image && typeof parsedData.image === 'object') {
          colorSwatchData = parsedData.image;
        } else {
          // Use the data directly if it's not nested
          colorSwatchData = parsedData;
        }
      } catch (e) {
        console.warn('Failed to parse color-swatch-image JSON for metafields:', e);
        return;
      }

      // Check if this is metafield format (keys are just product IDs, not "ID - Color")
      const firstKey = Object.keys(colorSwatchData)[0];
      if (!firstKey || firstKey.includes(' - ')) {
        // This is variant format, not metafield format
        return;
      }

      // Find color swatch elements (for products without options, these are in .color-swatch-products)
      const colorSwatchElements = document.querySelectorAll('.color-swatch-products-wrap .color-swatch-products li');
      
      colorSwatchElements.forEach((element) => {
        // Get the link element
        const link = element.querySelector('a');
        if (!link) return;

        // Try to get product ID from data attribute on the link or list item
        let productId = link.dataset.productId || element.dataset.productId;
        
        // If no data attribute, try to extract from href
        if (!productId) {
          const href = link.getAttribute('href') || '';
          // The href might contain product handle, but we need the ID
          // We'll need to get it from the product data if available
        }

        // Try to get product ID from the link's data attributes or from the product wrapper
        // For metafield products, we might need to fetch the product ID differently
        // Check if there's a data-product-id attribute
        if (!productId && link.hasAttribute('data-product-id')) {
          productId = link.getAttribute('data-product-id');
        }

        // If we still don't have productId, try to get it from the current product's variant data
        // or from the page context
        if (!productId) {
          // For now, we'll need to rely on the JSON keys matching product IDs
          // The metafield structure should have product IDs available somewhere
          // Let's check all numeric keys in the JSON
          const numericKeys = Object.keys(colorSwatchData).filter(key => /^\d+$/.test(key));
          if (numericKeys.length === 1) {
            // If there's only one product ID in the JSON, use it
            productId = numericKeys[0];
          }
        }

        // If we have a product ID, look it up in the JSON
        if (productId) {
          const imageUrl = colorSwatchData[productId.toString()];
          
          if (imageUrl) {
            // Update the image src directly (for metafield color swatches)
            const img = element.querySelector('img');
            if (img) {
              img.src = imageUrl;
              img.srcset = '';
            }
            
            // Also update any label with --option-color-image if present
            const label = element.querySelector('label, [style*="--option-color"]');
            if (label) {
              const currentStyle = label.getAttribute('style') || '';
              // Remove existing --option-color-image if present
              const cleanedStyle = currentStyle.replace(/--option-color-image:\s*[^;]+;?/gi, '').trim();
              // Add the new --option-color-image
              const separator = cleanedStyle.endsWith(';') ? ' ' : '; ';
              label.setAttribute('style', cleanedStyle + separator + `--option-color-image: url('${imageUrl}');`);
            }
          }
        }
      });
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.pagination = this.parentElement.querySelector('.product-images-buttons');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      // Start Gallery
      let observer = new MutationObserver(() => {
        this.setupProductGallery();
      });

      observer.observe(this, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: false
      });

      this.setupProductGallery();

      // Start Pagination
      if (this.pagination) {
        this.setupPagination();
        this.resizeObserver = new ResizeObserver(entries => this.onPaginationResize());
        this.resizeObserver.observe(this);
        this.addEventListener('scroll', this.updatePagination.bind(this));
      }
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }

      this.setEventListeners();
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector('.product-single__media-zoom');
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute('title')
        };
      });
      return images;
    }
    setEventListeners() {
      let activeImages = Array.from(this.querySelectorAll('.product-images__slide--image')).filter(element => element.clientWidth > 0),
        items = this.buildItems(activeImages),
        captionEl = this.dataset.captions,
        pswpElement = document.querySelectorAll('.pswp')[0],
        options = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true
        };

      let openPswp = function (e, link, options, pswpElement, items) {
        let parent = link.closest('.product-images__slide');
        let i = activeImages.indexOf(parent);
        options.index = parseInt(i, 10);
        options.getThumbBoundsFn = () => {
          const thumbnail = link.closest('.product-single__media'),
            pageYScroll = window.scrollY || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        };
        if (typeof PhotoSwipe !== 'undefined') {
          let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

          pswp.listen('firstUpdate', () => {
            pswp.listen('parseVerticalMargin', function (item) {
              item.vGap = {
                top: 50,
                bottom: 50
              };
            });
          });
          pswp.init();
        }
        e.preventDefault();
      };
      this.querySelectorAll('.product-single__media-zoom').forEach(function (link) {
        let thumbnail = link.closest('.product-single__media');
        let clone = link.cloneNode(true);
        thumbnail.append(clone);
        link.remove();
        clone.addEventListener('click', (e) => openPswp(e, clone, options, pswpElement, items));
      });

      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
    }
    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');

      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');


      this.prevButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onPaginationButtonClick.bind(this));

      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);

      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.updatePagination();
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + (1 * this.sliderItemOffset) : this.scrollLeft - (1 * this.sliderItemOffset);
      this.scrollTo({
        left: this.slideScrollPosition
      });
    }
    updatePagination() {
      if (!this.nextButton) return;

      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.pageTotalElement) {
        this.pageTotalElement.textContent = this.sliderItemsToShow.length;
      }

      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.form.reportValidity()) {
        return;
      }

      const sectionId = this.dataset.section;
      const isDonationProduct = this.dataset.customDonationProduct === 'true';
      const donationVariantId = this.dataset.customDonationVariantId;


      if (isDonationProduct && donationVariantId) {
        const inputs = Array.from(document.querySelectorAll(`[data-custom-donation-section="${sectionId}"][data-custom-donation-input]`));
        const primaryInput = inputs[0];
        const raw = primaryInput ? String(primaryInput.value).trim() : '';

    

        const showDonationError = (msg) => {
        
          document.querySelectorAll(`[data-custom-donation-section="${sectionId}"][data-custom-donation-error]`).forEach((el) => {
            el.hidden = false;
            el.textContent = msg;
          });
          if (primaryInput) primaryInput.focus();
        };

        if (raw !== '') {
          const validFormat = /^(?:\d+\.?\d*|\.\d+)$/.test(raw);
          const num = parseFloat(raw);
        
          if (!validFormat || !Number.isFinite(num) || num <= 0) {
            showDonationError('Please enter a number greater than zero.');
            return;
          }
          document.querySelectorAll(`[data-custom-donation-section="${sectionId}"][data-custom-donation-error]`).forEach((el) => {
            el.hidden = true;
            el.textContent = '';
          });
         
          const idInput = this.form.querySelector('[name="id"]');
          if (idInput) {
            idInput.value = donationVariantId;
            idInput.disabled = false;
          }
        }
      }

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      let alreadyLoading = false;

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) {
          alreadyLoading = true;
        }
      });

      if (alreadyLoading) {
        return;
      }

      submitButtons.forEach((submitButton) => {
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);

      if (isDonationProduct && donationVariantId) {
        const inputs = Array.from(document.querySelectorAll(`[data-custom-donation-section="${sectionId}"][data-custom-donation-input]`));
        const raw = inputs[0] ? String(inputs[0].value).trim() : '';
        if (raw !== '') {
          const validFormat = /^(?:\d+\.?\d*|\.\d+)$/.test(raw);
          const num = parseFloat(raw);
          if (validFormat && Number.isFinite(num) && num > 0) {
            formData.set('id', donationVariantId);
            formData.append('properties[_custom_donation_amount]', raw);
          
          }
        } 
      }

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
     
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const sectionHTML = parsedState.sections && parsedState.sections[section.section];
        if (!sectionHTML) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        const newInnerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
        if (newInnerHTML !== null) {
          elementToReplace.innerHTML = newInnerHTML;
        }

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.notesToggle();
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }
        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.querySelector('.product-quick-images--container').classList.remove('active');
        document.body.classList.remove('open-quick-view');

        if (window.innerWidth < 1069) {
          product_drawer.classList.remove('active');
          if (document.getElementById('Cart-Drawer')) {
            document.getElementById('Cart-Drawer').classList.add('active');
            document.body.classList.add('open-cart');
            document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
            dispatchCustomEvent('cart-drawer:open');
          }
        } else {
          product_drawer.querySelector('.product-quick-images--container').addEventListener('transitionend', function () {
            product_drawer.classList.remove('active');

            if (document.getElementById('Cart-Drawer')) {
              document.getElementById('Cart-Drawer').classList.add('active');
              document.body.classList.add('open-cart');
              document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
              dispatchCustomEvent('cart-drawer:open');
            }
          });
        }

        if (!document.getElementById('Cart-Drawer')) {
          document.body.classList.remove('open-cc');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      if (!html) return null;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const target = parsed.querySelector(selector);
      if (target) {
        return target.innerHTML;
      }
      const body = parsed.querySelector('body');
      return body ? body.innerHTML : html;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    setupToggle() {
      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button.addEventListener('click', function () {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener('click', function () {
          content.classList.toggle('active');
          return false;
        });
      }


    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

document.addEventListener('change', function (e) {
  if (e.target.matches && e.target.matches('[data-custom-donation-input]')) {
    e.stopPropagation();
  }
}, true);

document.addEventListener('input', function (e) {
  if (!e.target.matches || !e.target.matches('[data-custom-donation-input]')) return;
  e.target.value = e.target.value.replace(/[^0-9.]/g, '');
  const sid = e.target.getAttribute('data-custom-donation-section');
  if (!sid) return;
  document.querySelectorAll(`[data-custom-donation-section="${sid}"][data-custom-donation-input]`).forEach((inp) => {
    if (inp !== e.target) inp.value = e.target.value;
  });
  document.querySelectorAll(`[data-custom-donation-section="${sid}"][data-custom-donation-error]`).forEach((err) => {
    err.hidden = true;
    err.textContent = '';
  });

  const productForm = document.querySelector(`product-form[data-section="${sid}"][data-custom-donation-product="true"]`);
  const donationVariantId = productForm && productForm.dataset.customDonationVariantId;
  const form = document.getElementById(`product-form-${sid}`);
  const idInput = form && form.querySelector('[name="id"]');
  if (!idInput || !donationVariantId) return;

  const raw = String(e.target.value).trim();
  if (raw !== '') {
    const validFormat = /^(?:\d+\.?\d*|\.\d+)$/.test(raw);
    const num = parseFloat(raw);
    if (validFormat && Number.isFinite(num) && num > 0) {
      idInput.value = donationVariantId;
      idInput.disabled = false;
      return;
    }
  }

  const variantSelects = document.getElementById(`variant-selects-${sid}`);
  if (variantSelects && variantSelects.currentVariant) {
    idInput.value = variantSelects.currentVariant.id;
    idInput.disabled = false;
  }
});

document.addEventListener('DOMContentLoaded', function() {
  if (typeof addIdToRecentlyViewed !== "undefined") {
    addIdToRecentlyViewed();
  }
  
  initializeBackorderDateForNoVariants();
});

function initializeBackorderDateForNoVariants() {
  const noVariantScripts = document.querySelectorAll('script[data-product-no-variants]');
  
  if (noVariantScripts.length === 0) {
    console.log('[Backorder] No products with default variant only found');
    return;
  }
  
  console.log('[Backorder] Found', noVariantScripts.length, 'product(s) with default variant');
  
  noVariantScripts.forEach(script => {
    const sectionId = script.getAttribute('data-product-no-variants');
    const backorderElement = document.getElementById(`backorder-date-${sectionId}`);
    const hiddenInput = document.getElementById(`estimated-ship-date-${sectionId}`);
    
    console.log('[Backorder] Processing section:', sectionId);
    console.log('[Backorder] Backorder element found:', !!backorderElement);
    console.log('[Backorder] Hidden input found:', !!hiddenInput);
    
    if (!backorderElement) {
      console.log('[Backorder] Skipping - no backorder element');
      return;
    }
    
    if (!hiddenInput) {
      console.log('[Backorder] Warning - no hidden input element found!');
    }
    
    try {
      const variantData = JSON.parse(script.textContent);
      if (!variantData || variantData.length === 0) return;
      
      const variant = variantData[0];
      const inventoryQuantity = variant?.inventory_quantity;

      if (inventoryQuantity != null && inventoryQuantity > 0) {
        backorderElement.classList.remove('active');
        if (hiddenInput) {
          hiddenInput.value = '';
          hiddenInput.disabled = true;
        }
        return;
      }

      const backorderDate = variant?.metafields?.global?.backordered_date;
      
      console.log('[Backorder] Raw backorder date:', backorderDate);
      
      if (!backorderDate || backorderDate === null || backorderDate === 'null') {
        backorderElement.classList.remove('active');
        if (hiddenInput) {
          hiddenInput.value = '';
          hiddenInput.disabled = true;
        }
        console.log('[Backorder] No valid backorder date');
        return;
      }
      
      const dateElement = backorderElement.querySelector('.backorder-date--value');
      if (!dateElement) {
        console.log('[Backorder] No date element found in backorder element');
        return;
      }
      
      let formattedDate = backorderDate;
      try {
        let dateStr = String(backorderDate).trim();
        
        if (dateStr.includes('T')) {
          dateStr = dateStr.split('T')[0];
        }
        if (dateStr.includes('+') || (dateStr.includes('-') && dateStr.match(/\d{4}-\d{2}-\d{2}-\d{2}:\d{2}/))) {
          dateStr = dateStr.split(/[+-]/)[0];
        }
        
        const dateParts = dateStr.split(/[-/]/);
        if (dateParts.length >= 3) {
          let year, month, day;
          
          if (dateParts[0].length === 4) {
            year = parseInt(dateParts[0], 10);
            const a = parseInt(dateParts[1], 10);
            const b = parseInt(dateParts[2], 10);
            if (a >= 1 && a <= 12 && b >= 1 && b <= 31) {
              month = a;
              day = b;
            } else if (b >= 1 && b <= 12 && a >= 1 && a <= 31) {
              month = b;
              day = a;
            } else {
              month = a;
              day = b;
            }
          } else {
            const firstPart = parseInt(dateParts[0], 10);
            const secondPart = parseInt(dateParts[1], 10);
            
            if (firstPart > 12 && secondPart <= 12) {
              day = firstPart;
              month = secondPart;
              year = parseInt(dateParts[2], 10);
            } else if (firstPart <= 12 && secondPart > 12) {
              month = firstPart;
              day = secondPart;
              year = parseInt(dateParts[2], 10);
            } else {
              month = firstPart;
              day = secondPart;
              year = parseInt(dateParts[2], 10);
            }
          }
          
          if (!isNaN(year) && !isNaN(month) && !isNaN(day) && month >= 1 && month <= 12 && day >= 1 && day <= 31) {
            formattedDate = `${String(month).padStart(2, '0')}/${String(day).padStart(2, '0')}/${year}`;
          } else {
            formattedDate = backorderDate;
          }
        } else {
          formattedDate = backorderDate;
        }
      } catch (e) {
        formattedDate = backorderDate;
      }
      
      dateElement.textContent = formattedDate;
      backorderElement.classList.add('active');
      backorderElement.style.display = '';
      backorderElement.style.visibility = '';
      
      if (hiddenInput) {
        hiddenInput.value = formattedDate;
        hiddenInput.disabled = false;
        console.log('[Backorder] Successfully set - Section:', sectionId, 'Value:', formattedDate, 'Input disabled:', hiddenInput.disabled);
      }
    } catch (e) {
      console.error('[Backorder] Error initializing backorder date for no-variant product:', e);
    }
  });
}